var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card, Image, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import Calendar from '../../assets/images/global/calendar-status.svg';
import { getPreferredTime } from '../../util/card-util';
import './card-appointments-detail-date-state.css';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import CardAppointmentsDetailDateStateAPI from './card-appointments-detail-date-state-api';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let CardAppointmentsDetailDateState = class CardAppointmentsDetailDateState extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
        };
    }
    static { this.propTypes = {
        dtAgendamento: string,
        hrAgendamento: string
    }; }
    getRenderDate() {
        const { dtAgendamento, dtDesejadaListaEspera } = this.props;
        const dateToShow = dtDesejadaListaEspera ? dtDesejadaListaEspera : dtAgendamento;
        ModelService;
        return (React.createElement(Text, { className: 'date', value: ModelService.format('date', dateToShow, { type: 'datePicker' }) }));
    }
    render() {
        const { hrAgendamento } = this.props;
        return (React.createElement(Card, { width: 12, selectable: false, selectionType: SelectionType.NONE, uuid: generateUUID(), className: 'card-appointments-detail-date' },
            React.createElement("div", { className: 'date-container' },
                React.createElement("div", { className: 'date-tag' },
                    React.createElement("div", { className: 'card-appointments-detail-icon' },
                        React.createElement(Image, { src: Calendar, alt: '' }),
                        React.createElement(Text, { bold: true, value: MessageService.translate('tws.field-list-date-time') }))),
                React.createElement("div", { className: 'date-action' },
                    React.createElement("div", { className: "column-date-information" },
                        React.createElement("div", { className: "date" }, this.getRenderDate()),
                        React.createElement(Text, { bold: true, className: 'hour-info', value: getPreferredTime(hrAgendamento) || '-' }))))));
    }
};
CardAppointmentsDetailDateState = __decorate([
    AwesomeComponent({ api: CardAppointmentsDetailDateStateAPI, type: ComponentType.DATA_DISPLAY })
], CardAppointmentsDetailDateState);
export default CardAppointmentsDetailDateState;
//# sourceMappingURL=card-appointments-detail-date-state.js.map